import { createRoot } from "react-dom/client";
import App from "./components/App";
import './basic.css';

const app = document.getElementById('app');
createRoot(app).render(<App />);
